const frontendEnvironmentSettingNames = [
    "APP_ENV",
    "BUILD_ID",
    "BUILD_TIMESTAMP",
    "DEBUG",
    "MEDIA_ENDPOINT",
    "STRIPE_PUBLIC_KEY",
    "STRIPE_ACCOMMODATION_PUBLIC_KEY",
] as const;
type FrontendEnvironmentSettingName =
    (typeof frontendEnvironmentSettingNames)[number];

type FrontendEnvironmentSetting = {
    readonly name: FrontendEnvironmentSettingName;
    readonly value: string | undefined;
};

export { frontendEnvironmentSettingNames };
export type { FrontendEnvironmentSetting, FrontendEnvironmentSettingName };
